import { render, staticRenderFns } from "./app.profile.vue?vue&type=template&id=fa485cb0&"
import script from "./app.profile.vue?vue&type=script&lang=js&"
export * from "./app.profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports